import React from "react";
import { ACTIVE_LAYERS, type ActiveLayer } from "@nexus/contracts";
import { LAYER_METADATA } from "../types";
import {
  BrainCircuit,
  Cpu,
  Zap,
  Bot,
  ShieldAlert,
  RadioTower,
  CheckCheck,
  RotateCcw,
} from "lucide-react";

interface LayerFiltersProps {
  activeLayers: Set<ActiveLayer>;
  onToggleLayer: (layer: ActiveLayer) => void;
  onSelectAll: () => void;
  onClearAll: () => void;
  layerCounts: Record<ActiveLayer, number>;
}

export const LayerFilters: React.FC<LayerFiltersProps> = ({
  activeLayers,
  onToggleLayer,
  onSelectAll,
  onClearAll,
  layerCounts,
}) => {
  const getIcon = (layer: ActiveLayer) => {
    switch (layer) {
      case "AI":
        return <BrainCircuit size={14} />;
      case "CHIP":
        return <Cpu size={14} />;
      case "ENERGY":
        return <Zap size={14} />;
      case "ROBOTICS":
        return <Bot size={14} />;
      case "CYBER":
        return <ShieldAlert size={14} />;
      case "HYBRID_WARFARE":
        return <RadioTower size={14} />;
      default:
        return <Cpu size={14} />;
    }
  };

  return (
    <div className="panel-section">
      <div className="section-title">
        <span>LAYER FILTERS (6)</span>
        <div style={{ display: "flex", gap: "6px" }}>
          <button
            className="btn-secondary"
            onClick={onSelectAll}
            title="모든 레이어 활성화"
            style={{ display: "flex", alignItems: "center", gap: "3px", padding: "2px 6px" }}
          >
            <CheckCheck size={11} /> 전체
          </button>
          <button
            className="btn-secondary"
            onClick={onClearAll}
            title="초기화"
            style={{ display: "flex", alignItems: "center", gap: "3px", padding: "2px 6px" }}
          >
            <RotateCcw size={11} /> 리셋
          </button>
        </div>
      </div>

      <div className="layer-grid">
        {ACTIVE_LAYERS.map((layerKey) => {
          const meta = LAYER_METADATA[layerKey];
          const isActive = activeLayers.has(layerKey);
          const count = layerCounts[layerKey] || 0;

          return (
            <button
              key={layerKey}
              className={`layer-toggle-btn ${isActive ? "active" : ""}`}
              onClick={() => onToggleLayer(layerKey)}
              style={
                {
                  "--layer-color": meta.color,
                  "--layer-glow": meta.glowColor,
                } as React.CSSProperties
              }
              title={`${meta.nameEn} — ${meta.description}`}
            >
              <div
                style={{
                  color: isActive ? meta.color : "var(--text-muted)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {getIcon(layerKey)}
              </div>

              <div className="layer-label-group">
                <span className="layer-name-ko">{meta.nameKo}</span>
                <span className="layer-name-en">{layerKey}</span>
              </div>

              <span className="layer-count-badge font-mono">{count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
